import { useQuery } from '@tanstack/react-query';
import { ChartSettings } from '../../../chart-settings/model';
import { getBitrateMeasurements } from '../../api';
import { mapNetworkServiceBitrateApiModelToNetworkServiceBitrateViewModel, NetworkServiceBitrateViewModel } from '../../model';
import { ThroughputMonitoredServiceQuery } from "../../config";
import { useAuthorizedAxios } from '../../../../core/hooks';

interface NetworkServiceBitrateApiResponse {
  networkServiceBitrateStatistics?: NetworkServiceBitrateViewModel | null;
  isFetching: boolean;
  isFetched: boolean;
}

export const useNetworkServiceBitratesApiGet = (
  customerId: number | null,
  itemId: number,
  throughput: number,
  chartSettings: ChartSettings,
  customQueryKeyPhrase: string,
): NetworkServiceBitrateApiResponse => {
  const axios = useAuthorizedAxios();
  const { data, isFetching, isFetched } = useQuery<NetworkServiceBitrateViewModel | null, Error>({
    queryKey: [
      ThroughputMonitoredServiceQuery['GetNetworkServiceBitrates'].key,
      customerId,
      itemId,
      chartSettings,
      customQueryKeyPhrase
    ],
    queryFn: async (): Promise<NetworkServiceBitrateViewModel | null> => {
      if (customerId === null) {
        return null;
      } else {
        const apiMeasurement = await getBitrateMeasurements(axios, { customerId, itemId, chartSettings });
        return mapNetworkServiceBitrateApiModelToNetworkServiceBitrateViewModel(apiMeasurement, throughput);
      }
    },
    gcTime: 30000,
    staleTime: 1000,
    structuralSharing: false
  });
  return {
    networkServiceBitrateStatistics: data,
    isFetching,
    isFetched
  };
};